module.exports = __webpack_public_path__ + "static/media/animated_imrul.a92803f0.png";